function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { trim } from 'lodash';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
var TarjetaEstadoComponentCtrl = /*#__PURE__*/function () {
  TarjetaEstadoComponentCtrl.$inject = ["$element", "$timeout", "$log", "NotifService", "AccesoDatos"];
  function TarjetaEstadoComponentCtrl($element, $timeout, $log, NotifService, AccesoDatos) {
    _classCallCheck(this, TarjetaEstadoComponentCtrl);
    _defineProperty(this, "dirty", false);
    _defineProperty(this, "editando", false);
    _defineProperty(this, "isnew", false);
    _defineProperty(this, "model", null);
    _defineProperty(this, "mails", {
      text: ''
    });
    this.$element = $element;
    this.$timeout = $timeout;
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(TarjetaEstadoComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[TarjetaEstadoComponentCtrl] onInit');
      this._initEstado(this.st);
      if (!this.st.st.idestado) {
        // sin pregunta?
        this.editarEstado();
      }
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      // this.$timeout(() => (this.$element.find('select') as any).formSelect(), 10)
    }
  }, {
    key: "_initEstado",
    value: function _initEstado(_st) {
      var _st$mails;
      this.isnew = !_st.st.idestado;
      this.model = {
        st: angular.copy(_st.st),
        mails: []
      };
      this.mails.text = ((_st$mails = _st.mails) === null || _st$mails === void 0 ? void 0 : _st$mails.map(function (m) {
        return m.mail;
      }).join('\n')) || '';
      this.dirty = false;
    }
  }, {
    key: "guardarEstado",
    value: function guardarEstado() {
      var _this = this;
      // separar los mails por líneas
      console.log('mails--> ', this.mails.text);

      // actualizar los mails
      this.model.mails = this._separaMails(this.mails.text);
      if (this.isnew) return this.AccesoDatos.Datos_Client.nuevoEstadoDoc(this.model) //
      .then(function (response) {
        return _this._initEstado(_this.st = response);
      });else this.AccesoDatos.Datos_Client.cambioEstadoDoc(this.st.st.idestado, this.model) //
      .then(function (response) {
        return _this._initEstado(_this.st = response);
      });
    }
  }, {
    key: "_separaMails",
    value: function _separaMails(text) {
      return text.split('\n').map(function (s) {
        return trim(s);
      });
    }
  }, {
    key: "editarEstado",
    value: function editarEstado() {
      var _this2 = this;
      this.editando = !this.editando;
      if (this.editando) this.$timeout(function () {
        return M.updateTextFields();
      }, 1);
      this.$timeout(function () {
        _this2.$timeout(function () {
          return _this2.$element.find('select').formSelect();
        }, 1);
        var textarea = _this2.$element.find('.materialize-textarea');
        if (textarea && textarea[0]) M.textareaAutoResize(textarea);
        if (_this2.isnew) {
          var textidentifier = _this2.$element.find('.st_identifier');
          if (textidentifier && textidentifier[0]) {
            textidentifier[0].focus();
          }
        }
      }, 200);
    }
  }, {
    key: "revertEstado",
    value: function revertEstado() {
      this._initEstado(this.st);
    }
  }]);
}();
angular.module('candidato').component('tarjetaEstado', {
  bindings: {
    st: '<'
  },
  controller: TarjetaEstadoComponentCtrl,
  template: require('./tarjeta-estado.component.html')
  // templateUrl: "tarjeta-estado.component.html",
});